import {SingleTargetRelation} from '../SingleTargetRelation';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import {SketchPointObject} from "../../../../../mesh/sketch";

let count = 0;


/**
 * 点-固定关系约束。
 */
export function isPointFixConstraint(value: object): value is PointFixConstraint {
    return Reflect.get(value, "isPointFixConstraint") === true;
}

export class PointFixConstraint extends SingleTargetRelation<SketchPointObject> {
    readonly isPointFixConstraint: boolean = true;
    /**
     * 关系类型。
     */
    public relationType = SketchRelationKind.Fix;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    public get baseDisplayName(): string {
        return '固定';
    }

}


